import { STORAGE_KEY } from '@src/constants';
import { IUserProfile } from '@src/interfaces/profile.interfaces';
import { IUserRole } from '@src/interfaces/user.interfaces';

import { currentMeasurement } from './measure.helpers';
import {
  getDataLocaleWithEncryption,
  saveToLocaleWithEncryption,
} from './storage.helpers';

export const profileFormatData = (data?: IUserProfile) => {
  return {
    userProfile: data,
    ...currentMeasurement(data?.measurement?.value),
  };
};

export const checkUserRole = async (role?: IUserRole) => {
  const prevRole = await getDataLocaleWithEncryption<IUserRole>(
    STORAGE_KEY.ROLE,
  );
  if (role && !prevRole)
    await saveToLocaleWithEncryption(STORAGE_KEY.ROLE, role);
};
